import { render, staticRenderFns } from "./SubOrders.vue?vue&type=template&id=33974a03&scoped=true"
import script from "./SubOrders.vue?vue&type=script&lang=js"
export * from "./SubOrders.vue?vue&type=script&lang=js"
import style0 from "./SubOrders.vue?vue&type=style&index=0&id=33974a03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33974a03",
  null
  
)

export default component.exports